export default __webpack_public_path__ + "static/media/Orbitron-Medium.1a5c8e96.ttf";